import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./pages/Layout";
import MainPage from "./pages/MainPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AddRecipePage from "./pages/AddRecipePage";
import RecipesPage from "./pages/RecipesPage";
import RecipeDetailPage from "./pages/RecipeDetailPage";
import DayDetailsPage from "./pages/DayDetailsPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { FontenehusProvider } from "./context/FontenehusContext";
import { UserProvider } from "./context/UserContext";
import AboutPage from "./pages/AboutPage";
import AdminDashboard from "./pages/AdminDashboardPage";
import AdminRoute from "./components/AdminRoute";
import AdminUserProfiles from "./pages/AdminUserProfilesPage";
import UserSettingsPage from "./pages/UserSettingsPage";
import "./index.css";
import AdminFontenehusProfile from "./pages/AdminFontenehusProfilePage";
import { ModalProvider } from "./context/ModalContext";
import { RefreshProvider } from "./context/RefreshContext ";
import { ConfirmDialogProvider } from "./context/ConfirmContext ";
import PrivacyPage from "./pages/PrivacyPage";
import ContactPage from "./pages/ContactPage";

const App: React.FC = () => {
  return (
    <Router>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        style={{ zIndex: 99999 }}
        theme="colored"
      />
      <FontenehusProvider>
        <UserProvider>
          <ModalProvider>
            <RefreshProvider>
              <ConfirmDialogProvider>
                <AppRoutes></AppRoutes>
              </ConfirmDialogProvider>
            </RefreshProvider>
          </ModalProvider>
        </UserProvider>
      </FontenehusProvider>
    </Router>
  );
};

export default App;

// ✅ Wrapper to allow useLocation() for route keys
const AppRoutes = () => {
  const location = useLocation();

  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/main" element={<MainPage />} />
        <Route path="/oppskrifter" element={<RecipesPage />} />
        <Route path="/oppskrifter/ny" element={<AddRecipePage />} />
        <Route
          path="/oppskrifter/:id"
          element={<RecipeDetailPage isOpen={false} />}
        />
        <Route path="/bruker/innstillinger" element={<UserSettingsPage />} />
        <Route path="/dagsmeny/dagens" element={<Navigate to="/dagsmeny" />} />

        {/* ✅ this re-renders the page on every navigation */}
        <Route
          path="/dagsmeny"
          element={<DayDetailsPage key={location.key} />}
        />

        <Route path="/om" element={<AboutPage />} />
        <Route path="/personvern" element={<PrivacyPage />} />
        <Route path="/kontakt" element={<ContactPage />} />

        {/* Admin routes */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />
        {/* Admin routes */}
        <Route
          path="/admin/fontenehus/:id"
          element={
            <AdminRoute>
              <AdminFontenehusProfile />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/user/:id"
          element={
            <AdminRoute>
              <AdminUserProfiles />
            </AdminRoute>
          }
        />
      </Route>

      <Route path="/" element={<LoginPage />} />
      <Route path="/registrer" element={<RegisterPage />} />
      <Route path="/glemt-passord" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
    </Routes>
  );
};
